function AppName() {
  let appEnv = process.env.REACT_APP_ENV;
  appEnv = appEnv.substr(0, 1).toUpperCase() + appEnv.substr(1);
  const appName = 'ControlPoint';
  return (
    <div className="col-auto align-self-center pr-0">
      <div className="row cfa-nowrap-row">
        <span className="nav-app-name">{appName}</span>
      </div>
      <div className="row cfa-nowrap-row">
        <span className="nav-app-name">
          {'{'}
          {appEnv}
          {'}'}
        </span>
      </div>
    </div>
  );
}

export default AppName;
